export const ChartColors = {
  TRANSPARENT: 'rgba(0,0,0,0)',
  NEEDLE: 'rgb(161,161,161)',
  WHITE: '#ffffff',
  ARMY_GREEN: '#377D60',
  ARMY_GREEN2: '#61B090',
  ARMY_GREEN3: '#75A000',
  ARMY_GREEN4: '#A1C731',
  DARK_BLUE: '#154E70',
  BLUE: '#287EB9',
  LIGHT_BLUE: '#36A4D9',
  LIGHTER_BLUE: '#3FBCF1',
  GREY: '#CDCDCD',
  TEAL: '#65C7CA',
  DARK_TEAL: '#34948E',
  DOWN: '#E43F03',
  UP: '#319466',
  LGLIME: '#96C121',
  LGGREEN: '#4CA686',
  RED: 'rgb(219,40,41)',
  RED_FADE1: 'rgba(219,40,41,0.6)',
  RED_FADE2: 'rgba(219,40,41,0.4)',
  RED_FADE3: 'rgba(219,40,41,0.2)',
  GREEN: 'rgb(180,203,26)',
  GREEN_FADE1: 'rgba(180,203,26,0.6)',
  GREEN_FADE2: 'rgba(180,203,26,0.4)',
  GREEN_FADE3: 'rgba(180,203,26,0.2)',
  MINT: '#61AF90',
  YELLOW: 'rgb(249,189,8)',
  YELLOW_FADE1: 'rgba(249,189,8,0.6)',
  YELLOW_FADE2: 'rgba(249,189,8,0.4)',
  YELLOW_FADE3: 'rgba(249,189,8,0.2)',
  GOOD: '#A1C731',
  OK: '#75A000',
  HIGH_USAGE: '#486F25',
  MAINTENANCE: '#E9863E',
  OUTAGE: '#BA5036',
  RISK_CRITICAL: '#D3471F',
  RISK_HIGH: '#F78A36',
  RISK_MODERATE: '#FBD741',
  RISK_LOW: '#CDE041',
  RISK_MINIMAL: '#A2C800',
  RISK_NONE: '#61B090'
};

export const chartBlues = [
  ChartColors.DARK_BLUE,
  ChartColors.BLUE,
  ChartColors.LIGHT_BLUE,
  ChartColors.LIGHTER_BLUE,
  ChartColors.GREY
];
export const chartTeals = [
  ChartColors.TEAL,
  ChartColors.DARK_TEAL,
  ChartColors.GREY
];
export const chartFlag = [
  ChartColors.RED,
  ChartColors.GREEN,
  ChartColors.YELLOW,
  ChartColors.MINT,
  ChartColors.GREY
];
export const chartArmyGreen = [
  ChartColors.ARMY_GREEN,
  ChartColors.ARMY_GREEN2,
  ChartColors.ARMY_GREEN3,
  ChartColors.ARMY_GREEN4
];
